import { useEffect, useState } from "react";
import Icon from "../../Icon/Icon";
import styles from "./SearchBar.module.css";

type NavigationSidebarPropsType = {
  handleSearch: (value: string) => void;
  className?: string;
  placeholder: string;
};

const SearchBar = ({
  handleSearch,
  className,
  placeholder,
}: NavigationSidebarPropsType) => {
  const [inputValue, setInputValue] = useState(""); // локальное состояние
  const [debouncedValue, setDebouncedValue] = useState(inputValue);

  // Дебаунс логика: обновляет debouncedValue только спустя 400мс после ввода
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 400);

    return () => clearTimeout(handler);
  }, [inputValue]);

  // Когда debouncedValue обновляется — вызываем handleSearch
  useEffect(() => {
    handleSearch(debouncedValue);
  }, [debouncedValue, handleSearch]);

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setInputValue(e.currentTarget.value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    handleSearch(inputValue); // При сабмите — мгновенный вызов
  };

  return (
    <form
      className={`${styles.inputWrapper} ${className}`}
      onSubmit={handleSubmit}
    >
      <input
        className={styles.input}
        onChange={handleInput}
        name="searchbar"
        type="text"
        value={inputValue}
        placeholder={placeholder}
      />
      <button type="submit" className={styles.searchButton}>
        <Icon
          name="search"
          size={30}
          color="#f2f2f2"
          className={styles.searchIcon}
        />
      </button>
    </form>
  );
};

export default SearchBar;
